






import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      show: false,
      message: ""
    };
  },
  created() {
    this.$store.watch(
      state => state.snackMessage,
      () => {
        const msg = this.$store.state.snackMessage;
        if (msg != "") {
          this.message = msg;
          this.show = true;
          this.$store.commit("setSnack", "");
        }
      }
    );
  }
});
